const shopGridCarousel = {
  displayField: 'title',
  name: 'Shop Grid Carousel',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'btnLabel',
      name: 'Button Label',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'btnUrl',
      name: 'Button URL',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'shopGridCarousel',
    version: 12,
    updatedAt: '2023-08-03T14:28:45.511Z'
  }
};
export default shopGridCarousel;